import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { theme } from "../../theme";
import { 
    Box, Container, Grid, Card, CardContent, Typography, 
    CircularProgress, Stack, Chip, Button, Divider
} from "@mui/material";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { 
    PeopleAltOutlined, AccountBalanceWalletOutlined, 
    MoneyOffOutlined, AnalyticsOutlined, ShoppingBagOutlined, 
    AutorenewOutlined, AccessTimeOutlined, CardGiftcardOutlined,
    CasinoOutlined, GroupOutlined
} from "@mui/icons-material";
import axios from "axios";
import { DashboardLayout } from "../../components/dashboard-layout";

// TẠO THEME CHUẨN METRONIC KÈM FONT PLUS JAKARTA SANS
const metronicTheme = createTheme({
    palette: {
        background: { default: "#F5F8FA", paper: "#FFFFFF" }, 
        text: { primary: "#181C32", secondary: "#7E8299" }, 
        primary: { main: "#1B84FF", light: "#F1FAFF" },
        success: { main: "#50CD89", light: "#E8FFF3" },
        danger: { main: "#F1416C", light: "#FFF5F8" },
        warning: { main: "#FFC700", light: "#FFF8DD" },
        purple: { main: "#7239EA", light: "#F8F5FF" },
        dark: { main: "#181C32", light: "#3F4254" }
    },
    typography: { fontFamily: "'Plus Jakarta Sans', sans-serif" },
    components: {
        MuiCard: { styleOverrides: { root: { borderRadius: "12px", boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.03)", border: "1px solid #E4E6EF" } } },
        MuiButton: { styleOverrides: { root: { fontFamily: "'Plus Jakarta Sans', sans-serif" } } }
    }
});

axios.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("user");
        if (token) config.headers["Authorization"] = `Bearer ${token}`;
        return config;
    },
    (error) => Promise.reject(error)
);

// =====================================================================
// COMPONENT ĐỘC QUYỀN: THẺ GIÁM SÁT GAME TỐI ƯU HIỆU NĂNG (ANTI-LAG)
// =====================================================================
const GameMonitorCard = ({ title, apiPathAdmin, apiPathCurrent, totalSeconds, type }) => {
    const [bet, setBet] = useState(null);
    const [timeLeft, setTimeLeft] = useState(totalSeconds);
    const [playerCount, setPlayerCount] = useState(0);

    const fetchSessionData = () => {
        axios.get(`${process.env.REACT_APP_API_URL}${apiPathAdmin}`)
            .then(res => { if (res.data?.data?.[0]) setBet(res.data.data[0]); })
            .catch(() => {});
    };

    const fetchPlayerCount = () => {
        axios.get(`${process.env.REACT_APP_API_URL}${apiPathCurrent}`)
            .then(res => { setPlayerCount(res.data?.data?.length || 0); })
            .catch(() => {});
    };

    useEffect(() => {
        fetchSessionData();
        fetchPlayerCount();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [apiPathAdmin, apiPathCurrent]);

    useEffect(() => {
        const timer = setInterval(() => {
            if (!bet) return;
            const createdTime = new Date(bet.createdAt).getTime();
            const now = new Date().getTime();
            const diffSeconds = Math.floor((now - createdTime) / 1000);
            const remaining = totalSeconds - diffSeconds;

            if (remaining <= 0) {
                setTimeLeft(0);
                fetchSessionData(); 
                fetchPlayerCount(); 
            } else {
                setTimeLeft(remaining);
                // Cập nhật số người chơi mỗi 5 giây để web mượt mà không lag
                if (remaining % 5 === 0) fetchPlayerCount();
            }
        }, 1000);
        return () => clearInterval(timer);
    }, [bet, totalSeconds]);

    // HÀM XỬ LÝ DỮ LIỆU ĐÃ BỔ SUNG CHẴN / LẺ CHO TÀI XỈU
    const getResultDisplay = () => {
        if (!bet || !bet.result) return { label: "Đang chờ", detail: "Chưa có kết quả...", bgColor: "#A1A5B7", textColor: "#7E8299" };
        
        // Lọc sạch mọi dấu cách, chỉ lấy số (VD: "5 5 4" -> "554")
        const cleanStr = String(bet.result).replace(/[^0-9]/g, '');

        if (type === 'TX') {
            if (cleanStr.length !== 3) return { label: bet.result, detail: "Dữ liệu lỗi", bgColor: "#181C32", textColor: "#7E8299" };
            const digits = cleanStr.split('').map(Number);
            const sum = digits.reduce((a, b) => a + b, 0);
            
            const isTai = sum > 10; // Từ 11 trở lên là TÀI
            const chanLeText = sum % 2 === 0 ? "CHẴN" : "LẺ"; // Tính Chẵn Lẻ
            
            return { 
                label: isTai ? "TÀI" : "XỈU", 
                detail: `${digits.join(' - ')} | Tổng ${sum} • ${chanLeText}`, 
                bgColor: isTai ? "#F1416C" : "#1B84FF", 
                textColor: isTai ? "#F1416C" : "#1B84FF" 
            };
        } 
        
        if (type === 'XD') {
            if (cleanStr.length !== 4) return { label: bet.result, detail: "Dữ liệu lỗi", bgColor: "#181C32", textColor: "#7E8299" };
            const digits = cleanStr.split('').map(Number);
            const redCount = digits.filter(d => d === 1).length;
            const whiteCount = 4 - redCount;

            let label = "CHẴN"; let detail = `${whiteCount} Trắng - ${redCount} Đỏ`; let bgColor = "#50CD89"; let textColor = "#50CD89";
            if (redCount === 0) { bgColor = "#A1A5B7"; textColor = "#A1A5B7"; detail = "4 Trắng"; }
            else if (redCount === 1) { label = "LẺ"; bgColor = "#1B84FF"; textColor = "#1B84FF"; }
            else if (redCount === 3) { label = "LẺ"; bgColor = "#FFC700"; textColor = "#FFC700"; }
            else if (redCount === 4) { bgColor = "#F1416C"; textColor = "#F1416C"; detail = "4 Đỏ"; }
            
            return { label, detail, bgColor, textColor };
        }
        
        return { label: bet.result, detail: "", bgColor: "#181C32", textColor: "#7E8299" };
    };

    const isDanger = timeLeft <= 10;
    const resultData = getResultDisplay();

    return (
        <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column', position: 'relative', overflow: 'hidden' }}>
            {isDanger && (
                <Box sx={{ 
                    position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(241, 65, 108, 0.05)', zIndex: 0, pointerEvents: 'none',
                    animation: 'pulseBg 1s infinite', '@keyframes pulseBg': { '0%': { opacity: 0.5 }, '50%': { opacity: 1 }, '100%': { opacity: 0.5 } }
                }} />
            )}
            <CardContent sx={{ p: 2.5, position: 'relative', zIndex: 1, display: 'flex', flexDirection: 'column', height: '100%', flexGrow: 1 }}>
                
                <Box display="flex" justifyContent="space-between" alignItems="flex-start" mb={2}>
                    <Box>
                        <Typography variant="caption" fontWeight="800" color="#A1A5B7" sx={{ textTransform: 'uppercase' }}>{title}</Typography>
                        <Typography variant="h6" fontWeight="800" color="#181C32" sx={{ lineHeight: 1.2, mt: 0.5 }}>#{bet ? bet.id_bet : '...'}</Typography>
                    </Box>
                    <Box sx={{ 
                        backgroundColor: isDanger ? '#F1416C' : '#181C32', color: '#FFF', px: 1.5, py: 0.8, borderRadius: '8px', 
                        display: 'flex', alignItems: 'center', gap: 0.5, boxShadow: isDanger ? '0 0 10px rgba(241, 65, 108, 0.5)' : 'none',
                        transition: 'background-color 0.3s'
                    }}>
                        <AccessTimeOutlined sx={{ fontSize: '16px' }} />
                        <Typography variant="subtitle1" fontWeight="800" sx={{ lineHeight: 1 }}>00:{timeLeft < 10 ? '0' : ''}{timeLeft}</Typography>
                    </Box>
                </Box>
                
                <Box display="flex" alignItems="center" gap={0.5} mb={3}>
                    <GroupOutlined sx={{ fontSize: '18px', color: '#50CD89' }} />
                    <Typography variant="body2" fontWeight="700" color="text.secondary">Đang cược: <strong style={{color: '#50CD89'}}>{playerCount}</strong> người</Typography>
                </Box>
                
                <Box sx={{ mt: 'auto', pt: 2, borderTop: '1px dashed #E4E6EF', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Box>
                        <Typography variant="caption" fontWeight="700" color="#A1A5B7" display="block" mb={0.5}>Dự báo kết quả</Typography>
                        <Typography variant="subtitle2" fontWeight="800" color={resultData.textColor}>{resultData.detail} • {resultData.label} </Typography>
                    </Box>
                     </Box>

            </CardContent>
        </Card>
    );
};

// =====================================================================
// COMPONENT DASHBOARD CHÍNH
// =====================================================================
function Dashboard() {
    const [data, setData] = useState(null);
    const [recentRecharges, setRecentRecharges] = useState([]);
    const [recentWithdraws, setRecentWithdraws] = useState([]);
    const [isLoading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            try {
                // 🟢 ĐÃ FIX LỖI PROMISE.ALL TẠI ĐÂY: Thêm .catch() cho từng API
                // Nếu một API lỗi, nó trả về null/mảng rỗng thay vì làm sập toàn bộ trang
                const [adminRes, employeeRes, napRes, rutRes] = await Promise.all([
                    axios.get(`${process.env.REACT_APP_API_URL}/statistic/getalladmin`).catch(() => ({ data: { data: null } })),
                    axios.get(`${process.env.REACT_APP_API_URL}/auth/getEmployee`).catch(() => ({ data: { data: [] } })),
                    axios.get(`${process.env.REACT_APP_API_URL}/payment/nap?page=1&limit=10`).catch(() => ({ data: { data: [] } })),
                    axios.get(`${process.env.REACT_APP_API_URL}/payment/rut?page=1&limit=10`).catch(() => ({ data: { data: [] } }))
                ]);
                
                if (adminRes.data?.data) setData(adminRes.data.data);
                if (employeeRes.data?.data) localStorage.setItem("data1", JSON.stringify(employeeRes.data.data));
                
                setRecentRecharges(napRes.data?.data || []);
                setRecentWithdraws(rutRes.data?.data || []);

            } catch (error) {
                console.error("Lỗi ngoại lệ khi fetch dữ liệu:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, []);

    const formatCurrency = (val) => new Intl.NumberFormat('vi-VN').format(val || 0) + ' ₫';
    const formatNumber = (val) => new Intl.NumberFormat('vi-VN').format(val || 0);

    const formatShortDate = (m) => {
        if (!m) return "";
        const d = new Date(m);
        return `${("0" + d.getHours()).slice(-2)}:${("0" + d.getMinutes()).slice(-2)} ${("0" + d.getDate()).slice(-2)}/${("0" + (d.getMonth() + 1)).slice(-2)}`;
    };

    const profitMiniGame = (data?.tongcuocminigame || 0) - (data?.tongthangminigame || 0);

    const MetronicStatCard = ({ title, value, icon, colorName }) => (
        <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', textAlign: 'left', border: 'none', boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.03)' }}>
            <CardContent sx={{ p: { xs: 2, sm: 3 }, display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1 }}>
                <Box sx={{ minWidth: 0, flexGrow: 1, textAlign: 'left !important' }}>
                    <Typography variant="subtitle2" textTransform="uppercase" sx={{ mb: 0.5, color: '#A1A5B7', fontWeight: 700, fontSize: '0.75rem', whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden', textAlign: 'left !important' }}>
                        {title}
                    </Typography>
                    <Typography variant="h5" sx={{ fontWeight: 800, color: '#181C32', fontSize: 'clamp(1.2rem, 2vw, 1.7rem)', whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden', textAlign: 'left !important' }}>
                        {value}
                    </Typography>
                </Box>
                <Box sx={{ width: 50, height: 50, borderRadius: '12px', flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: metronicTheme.palette[colorName].light, color: metronicTheme.palette[colorName].main }}>
                    {icon}
                </Box>
            </CardContent>
        </Card>
    );

    const TransactionTimeline = ({ dataList, type }) => {
        if (!dataList || dataList.length === 0) return <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center !important', py: 4 }}>Chưa có giao dịch nào.</Typography>;

        return (
            <Box className="safe-timeline" sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 0 }}>
                {dataList.map((item, index) => {
                    const isLast = index === dataList.length - 1;
                    let statusColor = "#FFC700"; let statusBg = "#FFF8DD"; let statusText = "Chờ";

                    if (item.status_payment === "Success") { statusColor = "#50CD89"; statusBg = "#E8FFF3"; statusText = "Thành công"; } 
                    else if (item.status_payment === "Deny") { statusColor = "#F1416C"; statusBg = "#FFF5F8"; statusText = "Từ chối"; }

                    if (type === 'rut') {
                        return (
                            <Box key={item._id} sx={{ display: 'flex', position: 'relative', pb: 2.5 }}>
                                {!isLast && <Box sx={{ position: 'absolute', left: '6px', top: '16px', bottom: 0, width: '2px', backgroundColor: '#F4F6FA' }} />}
                                <Box sx={{ width: 14, height: 14, borderRadius: '50%', backgroundColor: '#FFFFFF', flexShrink: 0, border: '2px solid', borderColor: '#F1416C', zIndex: 1, mt: 0.5, mr: 2 }} />
                                <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', width: '100%' }}>
                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 0.5, width: '100%' }}>
                                        <Typography variant="body2" sx={{ fontWeight: 600, color: '#181C32', fontSize: '0.95rem', textAlign: 'left !important' }}>{item.detail || "Sản phẩm đã xóa"}</Typography>
                                        <Typography variant="body2" sx={{ fontWeight: 700, color: '#1B84FF', fontSize: '0.95rem', textAlign: 'right !important' }}>{formatCurrency(item.money)}</Typography>
                                    </Box>
                                    <Typography variant="caption" sx={{ color: '#A1A5B7', fontWeight: 500, fontSize: '0.75rem', display: 'block', textAlign: 'left !important' }}>
                                        {item.user?.username || 'N/A'} • {formatShortDate(item.createdAt)}
                                    </Typography>
                                </Box>
                            </Box>
                        );
                    }

                    return (
                        <Box key={item._id} sx={{ display: 'flex', position: 'relative', pb: 2.5 }}>
                            {!isLast && <Box sx={{ position: 'absolute', left: '6px', top: '16px', bottom: 0, width: '2px', backgroundColor: '#F4F6FA' }} />}
                            <Box sx={{ width: 14, height: 14, borderRadius: '50%', backgroundColor: '#FFFFFF', flexShrink: 0, border: '2px solid', borderColor: statusColor, zIndex: 1, mt: 0.5, mr: 2 }} />
                            <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', width: '100%' }}>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 0.5, width: '100%' }}>
                                    <Typography variant="body2" sx={{ fontWeight: 700, color: '#181C32', fontSize: '0.95rem', textAlign: 'left !important' }}>+{formatCurrency(item.money)}</Typography>
                                    <Chip label={statusText} size="small" sx={{ backgroundColor: statusBg, color: statusColor, fontWeight: 700, fontSize: '0.7rem', height: '22px' }} />
                                </Box>
                                <Typography variant="caption" sx={{ color: '#A1A5B7', fontWeight: 500, fontSize: '0.75rem', display: 'block', textAlign: 'left !important' }}>
                                    {item.user?.username || 'N/A'} {item.transfer_code ? `` : ''} • {formatShortDate(item.createdAt)}
                                </Typography>
                            </Box>
                        </Box>
                    );
                })}
            </Box>
        );
    };

    return (

        
        <ThemeProvider theme={metronicTheme}>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');
                * { font-family: 'Plus Jakarta Sans', sans-serif !important; }
                .safe-timeline * { text-align: left !important; }

                .css-1ex5sxr-MuiTypography-root {
    margin: 0;
    font-size: 1.5rem;
    line-height: 1.375;
    font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji";
    color: #FF6600;
    font-weight: 800;
    letter-spacing: 1px;
    font-family: 'Inter', sans-serif;
}
            `}</style>

            <DashboardLayout>
                <Box component="main" sx={{ flexGrow: 1, py: 4, backgroundColor: 'background.default', minHeight: 'calc(100vh - 70px)' }}>
                    <Container maxWidth="xl">
                        {isLoading ? (
                            <Box display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
                                <CircularProgress size={50} sx={{ color: '#1B84FF' }} />
                            </Box>
                        ) : (
                            <Grid container spacing={3}>
                                
                                {/* ================== HÀNG 1: THỐNG KÊ TỔNG ================== */}
                                <Grid item xs={12} sm={6} md={6} lg={3}>
                                    <MetronicStatCard title="Tổng Thành Viên" value={formatNumber(data?.thanhvien)} icon={<PeopleAltOutlined fontSize="large" />} colorName="primary" />
                                </Grid>
                                <Grid item xs={12} sm={6} md={6} lg={3}>
                                    <MetronicStatCard title="Tổng Nạp" value={formatCurrency(data?.tongnaps)} icon={<AccountBalanceWalletOutlined fontSize="large" />} colorName="success" />
                                </Grid>
                                <Grid item xs={12} sm={6} md={6} lg={3}>
                                    <MetronicStatCard title="Tổng Rút" value={formatCurrency(data?.tongruts)} icon={<MoneyOffOutlined fontSize="large" />} colorName="warning" />
                                </Grid>
                                <Grid item xs={12} sm={6} md={6} lg={3}>
                                    <MetronicStatCard title="Tổng Cược" value={formatCurrency(data?.tongcuocminigame)} icon={<AnalyticsOutlined fontSize="large" />} colorName="purple" />
                                </Grid>

                                {/* ================== HÀNG 2: MÀN HÌNH THEO DÕI LIVE GAME ================== */}
                                <Grid item xs={12} mt={1}>
                                    <Typography variant="h6" fontWeight="800" color="#181C32" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                        <CasinoOutlined color="primary" /> Giám Sát Bàn Chơi Trực Tiếp
                                    </Typography>
                                </Grid>
                                
                                <Grid item xs={12} sm={6} md={3}>
                                    <GameMonitorCard title="Tài Xỉu 45S" apiPathAdmin="/TX45s/getadmin" apiPathCurrent="/TX45s/getcurrent" totalSeconds={45} type="TX" />
                                </Grid>
                                <Grid item xs={12} sm={6} md={3}>
                                    <GameMonitorCard title="Tài Xỉu 60S" apiPathAdmin="/TX60s/getadmin" apiPathCurrent="/TX60s/getcurrent" totalSeconds={60} type="TX" />
                                </Grid>
                                <Grid item xs={12} sm={6} md={3}>
                                    <GameMonitorCard title="Xóc Đĩa 45S" apiPathAdmin="/xd45s/getadmin" apiPathCurrent="/xd45s/getcurrent" totalSeconds={45} type="XD" />
                                </Grid>
                                <Grid item xs={12} sm={6} md={3}>
                                    <GameMonitorCard title="Xóc Đĩa 60S" apiPathAdmin="/xd60s/getadmin" apiPathCurrent="/xd60s/getcurrent" totalSeconds={60} type="XD" />
                                </Grid>

                                {/* ================== HÀNG 3: CONTROL PANEL ================== */}
                                <Grid item xs={12} lg={7} mt={1}>
                                    <Card sx={{ 
                                        height: '100%', background: 'linear-gradient(135deg, #1B84FF 0%, #0452B2 100%)', color: '#fff', position: 'relative', overflow: 'hidden', border: 'none', boxShadow: '0 10px 20px rgba(27, 132, 255, 0.2)'
                                    }}>
                                        <Box sx={{ position: 'absolute', top: '-30px', right: '-30px', width: '200px', height: '200px', borderRadius: '50%', background: 'rgba(255,255,255,0.05)' }} />
                                        <Box sx={{ position: 'absolute', bottom: '-40px', right: '80px', width: '120px', height: '120px', borderRadius: '50%', background: 'rgba(255,255,255,0.08)' }} />

                                        <CardContent sx={{ p: { xs: 3, sm: 5 }, position: 'relative', zIndex: 1, textAlign: 'left !important' }}>
                                            <Typography variant="h4" fontWeight="800" mb={2} sx={{ fontFamily: "'Plus Jakarta Sans', sans-serif", letterSpacing: '-0.5px' }}>
                                                Chào mừng trở lại, Quản trị viên! 👋
                                            </Typography>
                                            <Typography variant="body1" sx={{ opacity: 0.9, mb: 4, maxWidth: '500px', lineHeight: 1.6, fontSize: '0.95rem' }}>
                                                Hệ thống hiện đang có <strong>{data?.thanhvien || 0}</strong> thành viên tham gia. 
                                                Lợi nhuận MiniGame tạm tính là <strong style={{ color: profitMiniGame >= 0 ? '#50CD89' : '#F1416C' }}>{formatCurrency(profitMiniGame)}</strong>. 
                                                Đừng quên kiểm tra các đơn nạp/rút đang chờ duyệt nhé!
                                            </Typography>
                                            <Stack direction="row" spacing={2} flexWrap="wrap" useFlexGap>
                                                <Button component={Link} to="/admin/users" variant="contained" sx={{ backgroundColor: '#fff', color: '#1B84FF', fontWeight: 800, borderRadius: '8px', px: 3, py: 1.2, boxShadow: 'none', '&:hover': { backgroundColor: '#F1FAFF' } }}>
                                                    Quản lý User
                                                </Button>
                                                <Button component={Link} to="/admin/history" variant="outlined" sx={{ borderColor: 'rgba(255,255,255,0.5)', color: '#fff', fontWeight: 700, borderRadius: '8px', px: 3, py: 1.2, '&:hover': { borderColor: '#fff', backgroundColor: 'rgba(255,255,255,0.1)' } }}>
                                                    Xem Lịch Sử
                                                </Button>
                                            </Stack>
                                        </CardContent>
                                    </Card>
                                </Grid>

                                {/* DANH SÁCH VIỆC CẦN XỬ LÝ (PENDING) */}
                                <Grid item xs={12} lg={5} mt={1}>
                                    <Card sx={{ height: '100%', border: 'none', boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.03)' }}>
                                        <CardContent sx={{ p: 3, textAlign: 'left !important' }}>
                                            <Typography variant="h6" fontWeight="800" color="#181C32" mb={3} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                <AccessTimeOutlined sx={{ color: '#F1416C' }} /> Việc cần xử lý ngay
                                            </Typography>
                                            
                                            <Stack spacing={2.5}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', p: 2, borderRadius: '10px', border: '1px dashed #E4E6EF', backgroundColor: '#F9F9F9', transition: 'all 0.2s', '&:hover': { borderColor: '#FFC700', backgroundColor: '#FFF8DD' } }}>
                                                    <Box sx={{ width: 45, height: 45, borderRadius: '8px', backgroundColor: '#FFF8DD', color: '#FFC700', display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 2, flexShrink: 0 }}><AccountBalanceWalletOutlined /></Box>
                                                    <Box sx={{ flexGrow: 1, minWidth: 0 }}>
                                                        <Typography variant="subtitle2" fontWeight="800" color="#181C32">Nạp tiền (Pending)</Typography>
                                                        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontWeight: 600 }}>Khách chờ cộng điểm</Typography>
                                                    </Box>
                                                    <Typography variant="subtitle1" fontWeight="800" color="#FFC700" pl={1}>{formatCurrency(data?.tongnapp)}</Typography>
                                                </Box>

                                                <Box sx={{ display: 'flex', alignItems: 'center', p: 2, borderRadius: '10px', border: '1px dashed #E4E6EF', backgroundColor: '#F9F9F9', transition: 'all 0.2s', '&:hover': { borderColor: '#F1416C', backgroundColor: '#FFF5F8' } }}>
                                                    <Box sx={{ width: 45, height: 45, borderRadius: '8px', backgroundColor: '#FFF5F8', color: '#F1416C', display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 2, flexShrink: 0 }}><ShoppingBagOutlined /></Box>
                                                    <Box sx={{ flexGrow: 1, minWidth: 0 }}>
                                                        <Typography variant="subtitle2" fontWeight="800" color="#181C32">Rút tiền (Pending)</Typography>
                                                        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontWeight: 600 }}>Lệnh rút chờ xử lý</Typography>
                                                    </Box>
                                                    <Typography variant="subtitle1" fontWeight="800" color="#F1416C" pl={1}>{formatCurrency(data?.tongrutp)}</Typography>
                                                </Box>

                                              
                                            </Stack>
                                        </CardContent>
                                    </Card>
                                </Grid>

                                {/* ================== HÀNG 4: TIMELINE NẠP RÚT ================== */}
                                <Grid item xs={12} md={6}>
                                    <Card sx={{ height: '100%', border: 'none', boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.03)' }}>
                                        <CardContent sx={{ p: { xs: 2, sm: 3 } }}>
                                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                                                <Typography variant="subtitle1" fontWeight="800" sx={{ display: 'flex', alignItems: 'center', gap: 1, textAlign: 'left !important' }}>
                                                    <ShoppingBagOutlined sx={{ color: '#181C32' }} /> Đơn hàng gần đây
                                                </Typography>
                                                <Button component={Link} to="/admin/request" sx={{ textTransform: 'none', fontWeight: 700, fontSize: '0.8rem', color: '#1B84FF', '&:hover': { backgroundColor: 'transparent', textDecoration: 'underline' } }}>Tất cả</Button>
                                            </Box>
                                            <TransactionTimeline dataList={recentWithdraws} type="rut" />
                                        </CardContent>
                                    </Card>
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <Card sx={{ height: '100%', border: 'none', boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.03)' }}>
                                        <CardContent sx={{ p: { xs: 2, sm: 3 } }}>
                                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                                                <Typography variant="subtitle1" fontWeight="800" sx={{ display: 'flex', alignItems: 'center', gap: 1, textAlign: 'left !important' }}>
                                                    <AutorenewOutlined sx={{ color: '#181C32' }} /> Nạp tiền mới nhất
                                                </Typography>
                                                <Button component={Link} to="/admin/add" sx={{ textTransform: 'none', fontWeight: 700, fontSize: '0.8rem', color: '#1B84FF', '&:hover': { backgroundColor: 'transparent', textDecoration: 'underline' } }}>Tất cả</Button>
                                            </Box>
                                            <TransactionTimeline dataList={recentRecharges} type="nap" />
                                        </CardContent>
                                    </Card>
                                </Grid>

                            </Grid>
                        )}
                    </Container>
                </Box>
            </DashboardLayout>
        </ThemeProvider>
    );
}

export default Dashboard;